module.exports = __webpack_public_path__ + "img/hb-4.587a2710.png";